import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "h4 text-primary" }, "Goals", -1)
const _hoisted_3 = { class: "font-weight-bold text-primary" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "d-block d-md-flex" }
const _hoisted_7 = { class: "mr-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, " Set Date: ", -1)
const _hoisted_9 = { class: "text-primary" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, " Due Date: ", -1)
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = {
  key: 1,
  class: "card mb-3 shadow-sm"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "card-body border-0 rounded py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h6" }, "No Data Available")
], -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_card_row = _resolveComponent("card-row")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { crumbs: _ctx.crumbs }, null, 8, ["crumbs"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, null, {
        title: _withCtx(() => [
          _hoisted_2
        ]),
        button: _withCtx(() => [
          _createElementVNode("span", null, [
            _createElementVNode("button", {
              class: "btn btn-primary mr-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToRoute(`/admin/goals/new/${_ctx.employeeId}`)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "mr-1",
                icon: "plus-circle"
              }),
              _createTextVNode(" Add New ")
            ])
          ]),
          _createElementVNode("span", null, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push({ name: 'Employees' })))
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "mr-1",
                icon: "arrow-left"
              }),
              _createTextVNode(" Go Back ")
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Filter, {
        class: "mb-4",
        ref: "filter",
        "sort-prop": [
        {
          key: 'Name',
          value: 'name',
        },
        {
          key: 'Due Date',
          value: 'dueDate',
        },
        {
          key: 'Set Date',
          value: 'setDate',
        },
      ],
        onApplySort: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort($event)))
      }, null, 512),
      (_ctx.goals.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.goals, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id
            }, [
              _createVNode(_component_card_row, { avatar: false }, {
                details: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.description), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formateDate(item.setDate)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formateDate(item.dueDate)), 1)
                    ])
                  ])
                ]),
                actions: _withCtx(() => [
                  (_ctx.canEdit(item.dueDate))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "btn btn-sm btn-primary",
                        to: {
                name: 'Edit Goal',
                path: '/admin/goals/edit',
                params: { goalId: item.id },
              }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            class: "mr-1",
                            icon: "pencil-alt"
                          }),
                          _createTextVNode(" Edit ")
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)),
      (_ctx.totalCount > 15)
        ? (_openBlock(), _createBlock(_component_PaginationComponent, {
            key: 2,
            "page-count": _ctx.totalPages,
            perPage: _ctx.perPage,
            "click-handler": _ctx.goToPage
          }, null, 8, ["page-count", "perPage", "click-handler"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}